
import { useEffect, useRef, useState } from 'react';

export default function WhyDeluxe() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.15 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const benefits = [
    {
      text: 'Designed for high-ticket service brands',
      icon: 'ri-vip-crown-line',
    },
    {
      text: 'Built with enterprise-grade structure',
      icon: 'ri-shield-check-line',
    },
    {
      text: 'Premium aesthetic meets operational power',
      icon: 'ri-flashlight-line',
    },
    {
      text: 'Focused on ROI, not gimmicks',
      icon: 'ri-focus-3-line',
    },
  ];

  return (
    <section ref={sectionRef} className="bg-[#0B0D10] py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div
          className={`grid grid-cols-1 md:grid-cols-2 gap-8 items-center transition-all duration-1000 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Left Column - Large cinematic image */}
          <div className="relative order-2 md:order-1 rounded-3xl overflow-hidden">
            <div className="w-full h-[620px] overflow-hidden rounded-3xl">
              <img
                src="https://public.readdy.ai/ai/img_res/958da55df266b47e5f4a72916b43430e.jpg"
                alt="Premium AI Systems Workspace"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Right Column - Text */}
          <div className="order-1 md:order-2 md:pl-8">
            <p className="text-xs font-semibold tracking-[0.35em] text-[#8C9198] mb-5 uppercase">
              Why Choose Us
            </p>
            <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white leading-[1.08] tracking-tight">
              Why Deluxe<br />AI Systems?
            </h2>

            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className={`flex items-center gap-5 group transition-all duration-700 ${
                    visible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
                  }`}
                  style={{ transitionDelay: `${(index + 1) * 150 + 300}ms` }}
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-white/5 border border-white/10 flex-shrink-0 transition-all duration-300 group-hover:bg-white/10">
                    <i
                      className={`${benefit.icon} text-xl text-white/70 group-hover:text-white transition-colors duration-300`}
                    ></i>
                  </div>

                  <p className="text-lg text-[#C5C9CF] font-light leading-relaxed">
                    {benefit.text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
